/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import ControlRateComponents from 'components/ControlRate/controlRate.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const ControlRatePage = () => {
   return (
      <Fragment>
         <Helmet>
            <title>ควบคุมยอดตั้งสู้สมาชิก</title>
         </Helmet>
         <HasAccess
            roles={['Owner','Senior','Master','Agent']}
            permissions={["control_rate-list"]}
            renderAuthFailed={<ErrorPage404/>}
         >
            <ControlRateComponents/>
         </HasAccess>
      </Fragment>
   );
};

export default ControlRatePage;
